import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions'



export const visit = {

    data() {
        return {
            visits: [],
            visit_listener: [],
            singleVisit: {},
            listOfTypes: []

        }
    },
    methods: {
        async shareWith(email, url) {
            var sendEmail = firebase.functions().httpsCallable('share_with');
            await sendEmail({ email: email, url: url })
            console.log("share with, end!")
        },
        clearVisitData() {
            console.log("clearVisitData")
            this.visits = [];
            this.singleVisit = {};
            for (let l of this.visit_listener) {
                l();
            }
        },
        startListOfTypes(craft) {
            console.log("startListOfTypes")
            let vm = this
            let pre_sort = []
            let listener = firebase.firestore().collection("structure_rewenorth").onSnapshot(snapshot => {
                vm.listOfTypes = []
                snapshot.forEach((struct) => {
                    if (struct.data().craft == craft) {
                        let f = 0
                        for (let o of struct.data().order) {
                            if (o.includes("full_function")) {
                                f = parseInt(o.split("_")[1])
                                break;
                            }
                        }
                        //let first = struct.data().order[0];
                        //let f = parseInt(first.split("_")[1])
                        pre_sort.push({ id: struct.id, order: f })
                    }
                });
                pre_sort.sort((a, b) => (a.order > b.order) ? 1 : -1)
                for (let ps of pre_sort) {
                    vm.listOfTypes.push(ps.id);
                }
            });
            this.visit_listener.push(listener)
        },
        async createNewVisit(market_id, craft, market_owner, client) {
            let user = this.getUser();
            let newVisit = await firebase.firestore().collection("visits").add({
                craft: craft,
                market_id: market_id,
                store_name_app: this.singleMarket?.store_name_app,
                access: [user.client, market_owner],
                craftman_company: user.client,
                started_at: new Date().getTime(),
                locked: false
            });
            // add previusly added items:
            if (client) {
                let coll_ref = await firebase.firestore().collection("markets").doc(market_id).collection(client).get()
                coll_ref.forEach(async (c) => {
                    await firebase.firestore().collection("visits").doc(newVisit.id).collection("checklists").add({ component_id: c.id, ...c.data() })
                })
            }
            return newVisit.id
        },
        async updateVisit(visit_id, data) {
            await firebase.firestore().collection("visits").doc(visit_id).update(data)
        },
        startVisitsListener(market_id) {
            console.log("startVisitsListener")
            // TODO add order and limit here!
            let vm = this;
            let user = this.getUser();
            if (user.client === "rewe" || user.client === "chillservices") {
                let listenr = firebase.firestore().collection("visits")
                    .where("market_id", "==", market_id)
                    .onSnapshot(snapshot => {
                        vm.visits = [];
                        snapshot.forEach((v) => {
                            let d = v.data()
                            if (!d.deleted) {
                                d.visit_id = v.id
                                vm.visits.push(d)
                            }
                        })
                        vm.visits.sort((a, b) => a.started_at - b.started_at);
                    })
                this.visit_listener.push(listenr)
            } else {
                let listenr = firebase.firestore().collection("visits")
                    .where("access", "array-contains", user.client)
                    .where("market_id", "==", market_id)
                    .onSnapshot(snapshot => {
                        vm.visits = [];
                        snapshot.forEach((v) => {
                            let d = v.data()
                            if (!d.deleted) {
                                d.visit_id = v.id
                                vm.visits.push(d)
                            }
                        })
                        vm.visits.sort((a, b) => a.started_at - b.started_at);
                    })
                this.visit_listener.push(listenr)
            }
        },
        startSingleVisitListener(visit_id) {
            console.log("startSingleVisitListener");
            let vm = this;
            let listener = firebase.firestore().collection("visits").doc(visit_id).onSnapshot(snapshot => {
                vm.singleVisit = snapshot.data();
            });
            this.visit_listener.push(listener);
        },
        async checkChecklistsForFaultyData(visit_id) {
            let ref_get = await firebase.firestore().collection("visits").doc(visit_id).collection("checklists").get();
            let checklists = []
            ref_get.forEach((c) => {
                let data = c.data()
                if (!(data.name && data.front_image)) {
                    checklists.push(c.id)
                }
            });
            return checklists
        },
        async generateComponents(visit, visit_id, market_id) {
            let ref_get = await firebase.firestore().collection("visits").doc(visit_id).collection("checklists").get();
            let checklists = []
            ref_get.forEach((c) => {
                checklists.push({ checklist_id: c.id, ...c.data() })
            });
            for (let checklist of checklists) {
                if (!(checklist.front_image && checklist.name && checklist.type_plate_image)) {
                    continue;
                }

                if (checklist.component_id) {
                    let check_ref = firebase.firestore().collection("markets").doc(market_id)
                        .collection(localStorage.getItem("user_client")).doc(checklist.component_id)
                    await check_ref.update(
                        {
                            front_image: checklist.front_image,
                            name: checklist.name,
                            old_type_plate_image: checklist.type_plate_image ?? "",
                            checklists: firebase.firestore.FieldValue.arrayUnion(checklist.checklist_id)
                        });
                    if (checklist.comment) {
                        await check_ref.update({ old_comments: firebase.firestore.FieldValue.arrayUnion(checklist.comment) });
                    }
                } else {
                    let og_data = {
                        type: checklist.type,
                        name: checklist.name,
                        front_image: checklist.front_image,
                        old_comments: [],
                        old_type_plate_image: checklist.type_plate_image,
                        checklists: [checklist.checklist_id],
                    }
                    if (checklist.comment) {
                        og_data.old_comments.push(checklist.comment);
                    }
                    let add = await firebase.firestore().collection("markets").doc(market_id)
                        .collection(localStorage.getItem("user_client")).add(og_data);

                    await firebase.firestore().collection("visits").doc(visit_id).collection("checklists")
                        .doc(checklist.checklist_id).update({ component_id: add.id });

                }
            }
        },
    }
}